/* eslint-disable no-use-before-define */
import React from 'react';
import StringUtil from '@leverege/string-util';
import { GlobalState } from '@leverege/ui-redux';
import Unit from '@leverege/unit';
import StatsAttributeRendererCreator from "./StatsAttributeRendererCreator.js";
const unitMap = Unit.getUnitTypes().reduce((prev, curr) => {
  prev[curr] = true;
  return prev;
}, {});
export default {
  id: 'molten.attributeCreator.historyAggregation',
  type: 'historyAggregation',
  create(model, attr, opts) {
    const attribute = attr?.source?.attribute;
    if (!attr || !attribute) {
      return;
    }
    const {
      blueprint,
      molten
    } = opts;
    const {
      path
    } = attribute;
    const {
      options,
      name
    } = model;
    if (!options) {
      return;
    }
    const vt = attr.valueType;
    const isNumeric = vt === 'number' || vt === 'int' || vt === 'percent' || unitMap[vt] != null;
    if (!isNumeric) {
      return;
    }
    const fieldPath = `data/${path}`;
    const source = {
      type: 'imagine.Blueprint',
      field: fieldPath,
      editable: false,
      attribute,
      renamed: false,
      custom: true
    };
    const attrOpts = {
      filterable: false,
      sortable: false,
      i18nGetter: (...args) => attribute.getString(...args)
    };
    const objectType = blueprint.type;
    const range = options.range;
    const rangeString = range == null ? 'Dynamic' : typeof range === 'string' ? StringUtil.camelCaseToTitleCase(range) : `${range.start.toISOString()}-${range.end.toISOString()}`;
    const attrName = `${attr.name}.historyAggregation.${options.function}.${typeof range === 'string' ? range : rangeString}`;
    const a = {
      id: `${attr.id}.historyAggregation.${options.function}${range ? `.${range}` : '.dynamic'}`,
      name: attrName,
      displayName: name || `${StringUtil.camelCaseToTitleCase(attr.displayName)} ${StringUtil.capitalize(options.function)} (${range ? rangeString : 'Dynamic'})`,
      valueType: attribute.type,
      baseUnit: attribute.model.base,
      objectType,
      layout: {
        group: ['History Aggregations', attr.displayName, rangeString],
        sort: 'zzz'
      },
      get(obj) {
        const state = GlobalState.get().unifiedHistory;
        let value = state?.[`${obj.id}.${attrName}`]?.[0]?.value;
        value = value != null ? parseFloat(value) : value;
        if (attribute.model.base) {
          return {
            type: attribute.type,
            value,
            unit: attribute.model.base
          };
        }
        return value;
      },
      getOption(key) {
        return attrOpts[key];
      },
      blueprint: source,
      source
    };
    molten.addPlugin('Attribute', a);
    const TableRendererComponent = StatsAttributeRendererCreator.create(options, 'table');
    molten.addPlugin('AttributeCellRenderer', {
      objectType,
      attrName,
      renderer: (value, style, object) => {
        return /*#__PURE__*/React.createElement(TableRendererComponent, {
          value: value?.value,
          context: object,
          originalAttribute: attr,
          attribute: a,
          data: value,
          range
        });
      }
    });
    const DetailRendererComponent = StatsAttributeRendererCreator.create(options, 'detail');
    molten.addPlugin('AttributeValueRenderer', {
      objectType,
      attrName,
      renderer: (value, valueStyle, object, context, rendererOpts) => {
        return /*#__PURE__*/React.createElement(DetailRendererComponent, {
          value,
          context,
          originalAttribute: attr,
          attribute: a,
          data: value,
          object,
          range,
          valueStyle,
          rendererOpts
        });
      }
    });
  }
};